import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const instance = new Vuex.Store()

function addStore(moduleName, module) {
    if (!moduleName) throw new Error("moduleName can't be null,it should be string")
    if (!module) throw new Error("module can't be null,it should be object")
   
    module.namespaced = true

    module.state = Object.assign({}, module.state, this.config[moduleName])

    instance.registerModule(moduleName, module)
}

export default {
    instance,
    addStore
}
